<template>
  <div class="grid gap-4 ml-1">
    <label
      class="flex items-center px-12 py-18 mx-6 my-8 rounded cursor-pointer border-2 border-grey-300"
    >
      <h5 class="pl-12 text-sm font-semibold">
        {{ $t('rewards.reward_confirmation.no_contact_on_file') }}
      </h5>
    </label>
  </div>
</template>

<script>

export default {}
</script>
